/**
 * Shows Processing on Add to cart while /cart/add is in flight, and keeps
 * the button disabled until the cart UI settles. Does not intercept clicks.
 */
(function () {
  'use strict';

  var PROCESSING_CLASS = 'msl-atc-processing';
  var BUSY_CLASS = 'msl-atc-busy';
  var LABEL_ATTR = 'data-msl-atc-label';
  var SAFETY_MS = 15000;
  var ATC_SELECTOR = [
    '.gpo-clone-atc-button',
    '.gpo-clone-stickyAtc-button',
    'buy-buttons button[type="submit"]:not(.gpo-original-atc-button):not(.gpo-original-stickyAtc-button)',
    'form[is="product-form"] button[type="submit"]:not(.gpo-original-atc-button):not(.gpo-original-stickyAtc-button)',
    'product-sticky-bar button[type="submit"]:not(.gpo-original-atc-button):not(.gpo-original-stickyAtc-button)'
  ].join(',');

  var locked = false;
  var unlockTimer = null;
  var keepDisabledTimer = null;

  function processingLabel() {
    var strings = window.themeVariables && window.themeVariables.strings;
    return (strings && strings.processingButton) || 'Processing...';
  }

  function allAtcButtons() {
    return Array.from(document.querySelectorAll(ATC_SELECTOR));
  }

  function applyBusyUi() {
    allAtcButtons().forEach(function (btn) {
      if (!btn.getAttribute(LABEL_ATTR)) {
        btn.setAttribute(LABEL_ATTR, btn.innerHTML);
      }
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add(BUSY_CLASS);
      if (btn.innerHTML !== processingLabel()) {
        btn.innerHTML = processingLabel();
      }
    });
  }

  function clearBusyUi() {
    allAtcButtons().forEach(function (btn) {
      var saved = btn.getAttribute(LABEL_ATTR);
      if (saved != null) {
        btn.innerHTML = saved;
        btn.removeAttribute(LABEL_ATTR);
      }
      btn.removeAttribute('aria-busy');
      btn.classList.remove(BUSY_CLASS);

      var text = (btn.textContent || '').trim().toLowerCase();
      if (text.indexOf('sold out') === -1 && text.indexOf('unavailable') === -1) {
        btn.disabled = false;
        btn.removeAttribute('disabled');
      }
    });
  }

  function lockAtc() {
    locked = true;
    document.documentElement.classList.add(PROCESSING_CLASS);
    applyBusyUi();

    clearTimeout(unlockTimer);
    unlockTimer = setTimeout(unlockAtc, SAFETY_MS);

    clearInterval(keepDisabledTimer);
    keepDisabledTimer = setInterval(function () {
      if (!locked) {
        clearInterval(keepDisabledTimer);
        return;
      }
      applyBusyUi();
    }, 150);
  }

  function unlockAtc() {
    locked = false;
    document.documentElement.classList.remove(PROCESSING_CLASS);
    clearTimeout(unlockTimer);
    clearInterval(keepDisabledTimer);
    clearBusyUi();
  }

  function scheduleUnlock(delay) {
    clearTimeout(unlockTimer);
    unlockTimer = setTimeout(unlockAtc, delay || 800);
  }

  function isCartAddUrl(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (isCartAddUrl(url)) {
      lockAtc();
      return nativeFetch.apply(this, arguments).then(
        function (response) {
          if (!response.ok) {
            unlockAtc();
          } else {
            scheduleUnlock(1200);
          }
          return response;
        },
        function (error) {
          unlockAtc();
          throw error;
        }
      );
    }
    return nativeFetch.apply(this, arguments);
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._mslCartAdd = isCartAddUrl(url == null ? '' : String(url));
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr._mslCartAdd) {
      lockAtc();
      xhr.addEventListener('loadend', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          scheduleUnlock(1200);
        } else {
          unlockAtc();
        }
      });
    }
    return nativeSend.apply(this, arguments);
  };

  document.addEventListener('gpoAddedToCart', function () {
    scheduleUnlock(600);
  });

  document.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.baseEvent === 'variant:add') {
      scheduleUnlock(600);
    }
  });

  document.addEventListener('cart:error', unlockAtc);

  document.addEventListener('dialog:after-show', function (event) {
    if (event.target && event.target.matches && event.target.matches('cart-drawer')) {
      unlockAtc();
    }
  });

  var style = document.createElement('style');
  style.setAttribute('data-msl-atc-guard', 'true');
  style.textContent =
    '.' + BUSY_CLASS + '{opacity:.78;cursor:wait!important;}';
  document.head.appendChild(style);
})();
